import { httpCreate } from './http';

const http = httpCreate('/srv/activityGroup');

export const activityGroup = {
	getMyGroups() {
		return http.get('/', { params: {photoLive: 0 }});
	},
	addGroupTag(params) {
		params['photoLive'] = 0
		return http.post('/', params);
	},
	editGroupTagName(params) {
		return http.post(`/${params.id}`, { name: params.name });
	},
	deleteGroupTagName(params) {
		return http.delete(`/${params.id}`);
	},
	sortGroupTagName(params) {
		return http.post('/sort', params);
	},
	moveInGroup(params) {
		return http.post(`/moveIn/${params.activityId}/${params.id}`);
	},
	moveOutGroup(params) {
		return http.post(`/moveOut/${params.activityId}`);
	}
};
